<div *ngIf="isAdmin === true; else notAdmin">
  <label>{{"grupo-loja.highlighted-product-label" | translate}}</label>
  <input
    [formControl]="formControl"
    type="checkbox"
    clrCheckbox
  />
</div>
<ng-template #notAdmin>
  <div
    *ngIf="formControl.value"
    class="highlighted"
  >
    <clr-icon
      shape="star"
      solid
    ></clr-icon>
    <label>{{"grupo-loja.highlighted-product-label" | translate}}</label>
  </div>
</ng-template>
